module.exports = {"attached":"This :attribute is already attached.","relatable":"This :attribute may not be associated with this resource."};